import config from 'config/app.config'
import { GAMIFICATION_DATA } from 'socket-resources/event-constants/common-events'
import { io } from 'socket.io-client'

const useGamificationSocketNameSpace = () => {
  const listenGamificationData = (cb, authToken) => {
    const gamificationSocketInstance = io(`${config.SOCKET_URL}/gamification`, {
      transport: ['polling', 'websocket'],
      auth: {
        authorization: `Bearer ${authToken}`
      }
    })
    if (cb) {
      gamificationSocketInstance.on(GAMIFICATION_DATA, cb)
    }
    return () => {
      gamificationSocketInstance.off(GAMIFICATION_DATA, cb)
    }
  }

  return listenGamificationData
}

export default useGamificationSocketNameSpace

// import config from 'config/app.config'
// import { GAMIFICATION_DATA } from 'socket-resources/event-constants/common-events'
// import { io } from 'socket.io-client'
// import { useDispatch } from 'react-redux'
// import { setGamificationData } from 'redux-store/redux/slices/gamification.slice'

// const useGamificationSocketNameSpace = () => {
//   const dispatch = useDispatch()

//   const listenGamificationData = (cb, authToken) => {
//     const gamificationSocketInstance = io(`${config.SOCKET_URL}/gamification`, {
//       transport: ['polling', 'websocket'],
//       auth: {
//         authorization: `Bearer ${authToken}`
//       }
//     })
//     const handleData = (data) => {
//       dispatch(setGamificationData(data))
//       if (cb) cb(data)
//     }
//     gamificationSocketInstance.on(GAMIFICATION_DATA, handleData)
//     return () => {
//       gamificationSocketInstance.off(GAMIFICATION_DATA, handleData)
//     }
//   }

//   return { listenGamificationData }
// }

// export default useGamificationSocketNameSpace
